import React, { useState, useEffect, useMemo, FC } from "react";
import { Link } from "react-router-dom";
import Content from "../../../layout/content/Content";
import { Card, Badge, Alert } from "reactstrap";
import Head from "../../../layout/head/Head";
import { useForm, FormProvider } from "react-hook-form";
import { Label, Input, Row, Col } from "reactstrap";
import FormInput from "../../form-components/InputComponent";
import FormSelect from "../../form-components/SelectComponent";
import FormDatePicker from "../../form-components/DatePicker";
import FormTextArea from "../../form-components/TextAreaComponent";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  InputSwitch,
  Button,
} from "../../../components/Component";
import MastersAside from "../MastersAside";
import axios from "../../../axios";
import Swal from "sweetalert2";
import FormCheckbox from "../../form-components/CheckboxComponent";
import rolesApi from "../../../api/master/roles";
import ApprovalHeirarchyApis from "../../../api/master/approvalHeirarchy";
import usersApis from "../../../api/master/users";
import { message } from "antd";
import { useSelector } from "react-redux";
interface ApprovalLevel {
  level?: string | null;
  level_name?: string | null;
  level_value?: string | null;
}
interface SelectOptions {
  label: string;
  value: string;
}
const ApprovalHeirarchyMaster: FC<{
  id?: string | null;
  module?: string;
  data?: any;
  formAction?: string | null;
  setAction?: () => void;
  toggleModelPopUp: any;
}> = ({ id, module, formAction, toggleModelPopUp, data }) => {
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  const [action, setAction] = useState(formAction);
  const methods = useForm<any>({
    mode: "onChange",
    defaultValues: {
      level: "",
    },
  });
  const [approvalLevel, setApprovalLevel] = useState<ApprovalLevel[]>([]);
  const [selectedRoles, setSelectedRoles] = useState<string[]>([]);
  const [rolesList, setRolesList] = useState<SelectOptions[]>([]);
  const [approvalLevels, setApprovalLevels] = useState(0);
  const [globalData, setData] = useState<any>([]);
  const [sitesOptions, setSitesOptions] = useState<SelectOptions[]>([]);
  const [filteredSites, setFilteredSites] = useState<SelectOptions[]>([]);
  const [siteName, setSiteName] = useState<string | null>(null);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    trigger,
    reset,
  } = methods;

  const level = watch("level");
  const moduleId = watch("approvalModule");
  const currentSiteId = watch("siteId");

  const [accessibilityKeys, setaccessibilityKeys] = useState<any>([]);

  // Set Hierarchy For options: if selected module already has Org in fetchApprovalHierarchy, only show Site
  const hierarchyForOptions = useMemo(() => {
    const baseOptions = [
      { label: "Organisation", value: "Org" },
      { label: "Site", value: "Site" },
    ];
    if (!moduleId || action === "edit") return baseOptions;
    const hierarchyList = Array.isArray(data) ? data : data?.data || [];
    if (!hierarchyList.length) return baseOptions;
    const moduleName = accessibilityKeys.find(
      (k: any) => k.value === moduleId
    )?.label;
    const hasOrg = hierarchyList.some((item: any) => {
      const itemLevel =
        item.setHeirarchyFor ||
        item.setHierarchyFor ||
        item.approvalScope ||
        item.approvalFor;
      const isOrgLevel =
        itemLevel === "Org" ||
        itemLevel === "Organisation" ||
        (typeof itemLevel === "string" &&
          itemLevel.toLowerCase().includes("org"));
      const moduleMatches =
        item.approvalModuleName === moduleName ||
        item.approvalModule?.toString() === moduleId ||
        item.approvalModule == moduleId;
      const isActive = item.status === "Active" || !item.status;
      return moduleMatches && isActive && isOrgLevel;
    });
    if (hasOrg) return [{ label: "Site", value: "Site" }];
    return baseOptions;
  }, [moduleId, data, accessibilityKeys, action]);

  const [selectedOption, setSelectedOption] = useState(null);
  const [alertInfo, setAlertInfo] = useState<any>({
    type: "", // 'success' or 'error'
    message: "",
    errors: [],
  });
  const fetchModuleConfig = async () => {
    try {
      const res = await rolesApi.findAllModuleConfig({
        isReport: "false",
        isMaster: "false",
      });

      const moduleConfigData = res.data || [];

      // Show all modules from findAllModuleConfig API response
      setaccessibilityKeys(
        moduleConfigData.map((obj: any) => ({
          label: obj.moduleName,
          value: obj.moduleID.toString(),
        }))
      );
    } catch (err) {
      throw err;
    }
  };

  const onSubmit = async (formData: any) => {
    console.log("data", formData);
    try {
      const approvalScope = formData.level;
      if (approvalScope !== "Site") {
        formData.siteId = null;
      }
      if (!formData.siteId || formData.siteId === "") {
        formData.siteId = null;
      }
      formData.approvalScope = approvalScope;

      if (approvalScope === "Site" && formData.siteId) {
        const moduleName =
          accessibilityKeys.find((k: any) => k.value === formData.approvalModule)
            ?.label || module;
        const existing = data?.find(
          (item: any) =>
            item.approvalModuleName === moduleName &&
            item.siteId?.toString() === formData.siteId?.toString() &&
            (action === "edit" ? item.id !== id : true)
        );
        if (existing) {
          setAlertInfo({
            type: "error",
            message:
              "An active approval hierarchy already exists for this module and site combination",
            errors: [],
          });
          return;
        }
      }

      if (!action && !id) {
        let name: any = accessibilityKeys.find(
          (key: any) => key.value == formData.approvalModule
        );
        formData.approvalModuleName = name.label;
        formData.level = approvalLevel.map((level, index) => {
          const obj = {
            levelName: `level${index + 1}`,
            levelRole: formData[`level${index + 1}`],
          };
          delete formData[`level${index + 1}`];
          return obj;
        });
        formData.approvalType = formData.autoApproval ? "Auto" : "Multi-Level";
        formData.approvalCount = formData.approvalLevels;
        formData.isStrict = formData.isStrict || false;

        delete formData.autoApproval;
        delete formData.multiLevelApproval;
        delete formData.approvalLevels;
        console.log(JSON.stringify(formData));
        const { status, message } =
          await ApprovalHeirarchyApis.createApprovalHeirarchy(formData);
        if (status) {
          Swal.fire("Created!", "Hierarchy has been created", "success");
          toggleModelPopUp();
        } else {
          // Swal.fire("Failed!", message, "error");
          setAlertInfo({
            type: "error",
            message: message,
            errors: [],
          });
        }
      } else if (action === "edit") {
        console.log("edit", formData);
        const moduleName = globalData?.approvalModuleName || module;
        const moduleObj = accessibilityKeys.find(
          (key: any) => key.label == moduleName
        );
        console.log("1111");
        formData.approvalType = formData.autoApproval ? "Auto" : "Multi-Level";
        formData.approvalCount = formData.approvalLevels;
        formData.approvalScope = approvalScope;
        formData.siteId = approvalScope === "Site" ? formData.siteId : null;
        console.log("2222");
        formData.level = approvalLevel.map((level, index) => {
          const obj = {
            levelName: `level${index + 1}`,
            levelRole: formData[`level${index + 1}`],
          };
          delete formData[`level${index + 1}`];
          return obj;
        });
        console.log("3333", formData);
        formData.approvalModule = moduleObj?.value;
        console.log("4444");
        if (formData.autoApproval) {
          Object.assign(formData, {
            approvalModule: moduleObj?.value,
            approvalType: "Auto",
            approvalCount: 0,
            level: [],
            approvalScope,
            siteId: approvalScope === "Site" ? formData.siteId : null,
          });
        }
        console.log("formData::FINAL", formData);
        delete formData.autoApproval;
        delete formData.multiLevelApproval;
        delete formData.approvalLevels;
        console.log("formData::FINAL", formData);
        Object.keys(formData).forEach((key) => {
          // Check if the key starts with "level" and ends with a number
          if (/^level\d+$/.test(key)) {
            // Delete the key from the object
            delete formData[key];
          }
        });
        console.log("formData::FINAL:::Final", formData);

        const { status, message } =
          await ApprovalHeirarchyApis.updateApprovalHierarchyById(id, formData);
        if (status) {
          Swal.fire("Updated!", "Hierarchy has been updated", "success");
          toggleModelPopUp();
        } else {
          // Swal.fire("Failed!", message, "error");
          setAlertInfo({
            type: "error",
            message: message,
            errors: [],
          });
        }
      }
    } catch (error) { }
  };
  const fetchRoles = async () => {
    try {
      const { data, status, message } = await rolesApi.fetchRolesData();

      if (status) {
        setRolesList(
          data.map((obj: any) => ({
            label: obj.roleName,
            value: obj.roleID.toString(),
          }))
        );
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (err: any) {
      Swal.fire("Error", err.response?.data?.message || err.message, "error");
    }
  };

  const handleApprovalLevelsChange = (e: any) => {
    const value = parseInt(e.target.value, 10);
    if (value <= rolesList.length) {
      setApprovalLevels(value);
    } else {
      Swal.fire(
        "Error",
        `Approval levels cannot exceed the number of available roles (${rolesList.length})`,
        "error"
      );
    }
  };

  const handleCheckboxChange = (name: any) => {
    setSelectedOption((prev) => (prev === name ? null : name));
    if (name === "multiLevelApproval") {
      setValue("multiLevelApproval", !MultiLevelApproval);
      if (!MultiLevelApproval) {
        setValue("approvalLevels", 0); // Reset approval levels
        setApprovalLevel([]); // Clear the approval levels array
        setSelectedRoles([]); // Clear the selected roles
      }
    }

    if (name === "autoApproval") {
      setValue("autoApproval", !AutoApproval);
      if (!AutoApproval) {
        setValue("multiLevelApproval", false); // Deselect multiLevelApproval if autoApproval is selected
      }
    }

    if (name === "isStrict") {
      const newValue = !IsStrict;
      setValue("isStrict", newValue);
    }
  };

  const ApprovalLevels = watch("approvalLevels");
  const AutoApproval = watch("autoApproval");
  const MultiLevelApproval = watch("multiLevelApproval");
  const IsStrict = watch("isStrict");

  useEffect(() => {
    if (MultiLevelApproval) {
      setValue("autoApproval", false);
    } else if (AutoApproval) {
      setValue("multiLevelApproval", false);
      setApprovalLevel([]); // Clear approval levels when AutoApproval is selected
    }
  }, [MultiLevelApproval, AutoApproval]);

  // useEffect(() => {
  //   fetchModuleConfig();
  //   if (ApprovalLevels) {
  //     setApprovalLevel(Array.from({ length: ApprovalLevels }, () => ({})));
  //     setSelectedRoles(Array.from({ length: ApprovalLevels }, () => ""));
  //   }
  // }, [ApprovalLevels]);

  useEffect(() => {
    fetchModuleConfig();
  }, [data]);

  useEffect(() => {
    if (currentUser?.siteAccessibility) {
      setSitesOptions(
        currentUser.siteAccessibility.map((item: any) => ({
          label: item.siteName,
          value: item.siteID.toString(),
        }))
      );
    }
  }, [currentUser]);

  const filterSitesByModuleAndLevel = (approvalModuleId: string, levelVal: string) => {
    if (!approvalModuleId || !levelVal || !data?.length) {
      return sitesOptions;
    }
    const moduleObj = accessibilityKeys.find(
      (key: any) => key.value === approvalModuleId
    );
    const moduleName = moduleObj?.label || module;
    // Condition 2: (approvalModule == req.module) && approvalFor=Site && status=Active && siteId matched - hide from site dropdown
    const existingHierarchies = data.filter(
      (item: any) =>
        item.approvalModuleName === moduleName &&
        (item.status === "Active" || !item.status) &&
        (levelVal === "Site" ? item.siteId : !item.siteId) &&
        (action === "edit" ? item.id !== id : true)
    );
    if (levelVal === "Site") {
      const usedSiteIds = existingHierarchies
        .map((item: any) => item.siteId?.toString())
        .filter(Boolean);
      return sitesOptions.filter((site: SelectOptions) => {
        const isUsed = usedSiteIds.includes(site.value);
        const isCurrentSite =
          action === "edit" && site.value === currentSiteId?.toString();
        return !isUsed || isCurrentSite;
      });
    }
    return sitesOptions;
  };

  useEffect(() => {
    if (sitesOptions.length === 0) return;
    if (level === "Site") {
      if (moduleId) {
        const filtered = filterSitesByModuleAndLevel(moduleId, level);
        setFilteredSites(filtered);
        if (
          currentSiteId &&
          !filtered.find((site) => site.value === currentSiteId)
        ) {
          if (action !== "edit") {
            setValue("siteId", null);
          }
        }
      } else {
        setFilteredSites(sitesOptions);
      }
    } else if (action === "edit" && currentSiteId) {
      const currentSite = sitesOptions.find(
        (site) => site.value === currentSiteId?.toString()
      );
      setFilteredSites(currentSite ? [currentSite] : []);
    } else {
      setFilteredSites([]);
      if (action !== "edit") {
        setValue("siteId", null);
      }
    }
  }, [moduleId, level, sitesOptions, action, id, currentSiteId, data, setValue]);

  useEffect(() => {
    if (level && level !== "Site") {
      setValue("siteId", null);
    }
  }, [level, setValue]);

  // When module has Org and level is Org, reset to Site (Org not available in dropdown)
  useEffect(() => {
    if (
      action !== "edit" &&
      moduleId &&
      level === "Org" &&
      hierarchyForOptions.length === 1 &&
      hierarchyForOptions[0]?.value === "Site"
    ) {
      setValue("level", "Site");
    }
  }, [moduleId, level, hierarchyForOptions, action, setValue]);

  useEffect(() => {
    if (
      action === "edit" &&
      siteName &&
      !currentSiteId &&
      level === "Site" &&
      sitesOptions.length > 0
    ) {
      const matchedSite = sitesOptions.find((s) => s.label === siteName);
      if (matchedSite) {
        setValue("siteId", matchedSite.value);
      }
    }
  }, [action, siteName, currentSiteId, level, sitesOptions, setValue]);

  useEffect(() => {
    const maxLevels = 20;
    if (ApprovalLevels) {
      if (ApprovalLevels > maxLevels) {
        message.warning(`Maximum ${maxLevels} approval levels allowed.`);
      }
      const safeLevelCount = Math.min(Number(ApprovalLevels), maxLevels);
      setApprovalLevel(Array.from({ length: safeLevelCount }, () => ({})));
      setSelectedRoles(Array.from({ length: safeLevelCount }, () => ""));
    } else {
      // Clear when empty
      setApprovalLevel([]);
      setSelectedRoles([]);
    }
  }, [ApprovalLevels]);

  const fetchData = async () => {
    try {
      const response =
        await ApprovalHeirarchyApis.fetchApprovalHeirarchyById(id);
      const apiData = response?.data ?? response;
      const status = response?.status ?? !!apiData;
      const msg = response?.message;
      if (status && apiData) {
        setData(apiData);
        const moduleId =
          apiData.approvalModule ? String(apiData.approvalModule) :
          accessibilityKeys.find((k: any) => k.label === apiData.approvalModuleName)?.value ??
          apiData.approvalModuleName;
        setValue("approvalModule", moduleId ?? "");
        setValue("approvalLevels", apiData.approvalCount);
        setValue("autoApproval", apiData.approvalType === "Auto");
        setValue("multiLevelApproval", apiData.approvalType === "Multi-Level");
        setValue("isStrict", apiData.isStrict || false);
        setValue(
          "level",
          apiData.setHeirarchyFor || apiData.setHierarchyFor || apiData.approvalScope || apiData.approvalFor || "Org"
        );
        const scope = apiData.setHeirarchyFor || apiData.setHierarchyFor || apiData.approvalScope || apiData.approvalFor;
        const resolvedSiteId =
          scope === "Site" && apiData.siteId
            ? apiData.siteId
            : scope === "Site" && apiData.siteName && sitesOptions.length > 0
              ? sitesOptions.find((s) => s.label === apiData.siteName)?.value ?? null
              : null;
        setValue("siteId", apiData.siteId ?? resolvedSiteId);
        setSiteName(apiData.siteName || null);
        if (apiData.approvalType === "Multi-Level") {
          setApprovalLevels(apiData.approvalCount); // Ensure that approval levels are set
        }
        apiData?.level?.map((level: any, index: number) => {
          setValue(level.levelName, level.levelRole);
          // setSelectedRoles((pre)=>[...pre,level.levelRole]);
        });
      } else {
        Swal.fire("Error", msg, "error");
      }
    } catch (error: any) {
      console.log(error);

      Swal.fire("Error", error, "error");
    }
  };
  useEffect(() => {
    console.log("module");
    fetchRoles();
    // setValue("autoApproval", true);
    if (action === "edit") {
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (action === "edit" && globalData?.approvalModuleName) {
      const moduleId =
        globalData.approvalModule != null ? String(globalData.approvalModule) :
        accessibilityKeys.find((k: any) => k.label === globalData.approvalModuleName)?.value ||
        globalData.approvalModuleName;
      if (moduleId) {
        setValue("approvalModule", moduleId);
      }
    }
  }, [action, globalData?.approvalModuleName, globalData?.approvalModule, accessibilityKeys, setValue]);

  return (
    <>
      {alertInfo.message && (
        <div className="mb-3 mt-1">
          <Alert
            color={alertInfo.type === "error" ? "danger" : "success"}
            className="alert-icon"
          >
            <strong>{alertInfo.message}</strong>
            <Icon
              name={
                alertInfo.type === "error" ? "alert-circle" : "check-circle"
              }
            />
            {alertInfo.errors.length > 0 ? (
              <ul>
                {alertInfo.errors.map((err: any, index: any) => (
                  <li key={index}>{err}</li>
                ))}
              </ul>
            ) : (
              ""
            )}
          </Alert>
        </div>
      )}
      <h5 className="title">
        {action === "edit"
          ? `Edit ${globalData?.approvalModuleName || module}${siteName ? ` - ${siteName}` : ""} Hierarchy`
          : action === "view"
            ? "View Hierarchy"
            : "Create Hierarchy"}
      </h5>
      <div style={{ marginTop: "15px" }}></div>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {!MultiLevelApproval && <div style={{ marginTop: "20px" }}></div>}
          <Row className="gy-4">
            <Col lg="6">
              {action === "edit" ? (
                <FormSelect
                  name="approvalModule"
                  label="Approval Module Name"
                  options={
                    (globalData?.approvalModuleName || module)
                      ? [
                          {
                            label: globalData?.approvalModuleName || module,
                            value:
                              globalData?.approvalModule != null
                                ? String(globalData.approvalModule)
                                : accessibilityKeys.find(
                                    (k: any) =>
                                      k.label === (globalData?.approvalModuleName || module)
                                  )?.value || globalData?.approvalModuleName || module,
                          },
                        ]
                      : []
                  }
                  disabled={true}
                  required={true}
                />
              ) : (
                <FormSelect
                  name="approvalModule"
                  label="Approval Module Name"
                  options={accessibilityKeys}
                  required={true}
                />
              )}
            </Col>
            <Col lg="6">
              <FormSelect
                name="level"
                label="Set Heirarchy For"
                disabled={action === "view" || action === "edit"}
                options={hierarchyForOptions}
                placeholder="Select"
                required={true}
              />
            </Col>
          </Row>
          {(level === "Site" || (action === "edit" && currentSiteId)) && (
            <Row className="gy-4">
              <Col lg="6">
                <FormSelect
                  name="siteId"
                  label="Site"
                  placeholder={
                    filteredSites.length === 0 && moduleId
                      ? "No available sites for this module"
                      : "Select Site"
                  }
                  options={filteredSites}
                  disabled={
                    action === "edit" ||
                    (filteredSites.length === 0 && !!moduleId)
                  }
                  required={level === "Site"}
                />
              </Col>
            </Row>
          )}
          <Row className="gy-5 mt-0">
            <Col lg="4">
              <FormCheckbox
                name="autoApproval"
                optionLabel="Auto Approval"
                size={"small"}
                checked={AutoApproval}
                onChange={() => {
                  setValue("autoApproval", !AutoApproval);
                  handleCheckboxChange("autoApproval");
                }}
              />
            </Col>
            <Col lg="4">
              <FormCheckbox
                name="multiLevelApproval"
                optionLabel="Multi Level Approval"
                size={"small"}
                checked={MultiLevelApproval}
                onChange={() => {
                  handleCheckboxChange("multiLevelApproval");
                  setValue("multiLevelApproval", !MultiLevelApproval);
                }}
              />
            </Col>
            <Col lg="4">
              <FormCheckbox
                name="isStrict"
                optionLabel="Strict Approvals"
                size={"small"}
                checked={IsStrict}
                onChange={() => {
                  handleCheckboxChange("isStrict");
                }}
              />
            </Col>
          </Row>
          {!MultiLevelApproval && <div style={{ marginTop: "30px" }}></div>}
          <div style={{ marginTop: "20px" }}></div>

          {MultiLevelApproval && (
            <>
              <Row>
                <Col lg="6">
                  <FormInput
                    name="approvalLevels"
                    label="Approval Levels"
                    type="number"
                    required={true}
                    min={1}
                    onInput={(e: React.FormEvent<HTMLInputElement>) => {
                      const input = e.currentTarget;
                      let value = parseInt(input.value, 10);
                      if (isNaN(value)) return;

                      if (value > 20) {
                        value = 20;
                        input.value = value.toString();
                        message.warning("Maximum 20 approval levels allowed");
                      }
                    }}
                  />
                </Col>
              </Row>
              <div style={{ marginTop: "15px" }}></div>
              <Row className="gy-4">
                {approvalLevel.map((level, index) => (
                  <Col lg="6" key={index}>
                    <FormSelect
                      name={`level${index + 1}`}
                      label={`Level ${index + 1}`}
                      options={rolesList.filter(
                        (role) =>
                          role.value === selectedRoles[index] ||
                          !selectedRoles.includes(role.value)
                      )}
                      required={true}
                      onChange={(value) => {
                        setSelectedRoles((prev) => {
                          const newSelectedRoles = [...prev];
                          newSelectedRoles[index] = value;
                          return newSelectedRoles;
                        });
                      }}
                    />
                  </Col>
                ))}
              </Row>
            </>
          )}

          {action !== "view" ? (
            <Row className="mt-4">
              <Col lg="12">
                <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2 ">
                  <li>
                    <Button
                      className="btn btn-primary btn-md"
                      type="submit"
                      color="primary"
                    >
                      {/* <Icon name="check" /> */}
                      <span>{action === "edit" ? "Update" : "Submit"}</span>
                    </Button>
                  </li>
                  <li>
                    <Button
                      className="link link-light"
                      type="button"
                      onClick={() => {
                        toggleModelPopUp();
                      }}
                    >
                      {/* <Icon name="cross" /> */}
                      <span>Cancel</span>
                    </Button>
                  </li>
                </ul>
              </Col>
            </Row>
          ) : (
            <Row className="mt-4">
              <Col lg="12">
                <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                  <li>
                    <div
                      className="btn btn-primary btn-md"
                      color="primary"
                      onClick={() => setAction("edit")}
                    >
                      <Icon name="pen" />
                      <span>Edit</span>
                    </div>
                  </li>
                </ul>
              </Col>
            </Row>
          )}
        </form>
      </FormProvider>
    </>
  );
};

export default ApprovalHeirarchyMaster;
